// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1_5i3","footer":"Form_footer__11Ezl"};